import { Injectable } from '@angular/core';
import { ConnectionService } from '../connection/connection.service';
import { AppConstants } from '../../entity/constants';
import { Observable } from 'rxjs';
import { PreferenceResponseModel } from '../../models/preference';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {

  constructor(private readonly connectionService: ConnectionService) { }

  /**
   * To get All user Preference
   */
  getUserPreference() {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.PREFERENCE}/${AppConstants.USER}`,
      directoryType: AppConstants.DP,
      isLoader: true
    });
  }


  /**
   * To get the User Preference based upon the key
   * @param key Preference Key 
   */
  getUserPreferenceByKey(key: string) : Observable<PreferenceResponseModel>{
    const queryParams = {
      preferenceKey: key
    }
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: AppConstants.PREFERENCE,
      directoryType: AppConstants.DP,
      data: queryParams,
      isLoader: true
    });
  }


  /**
   * To Save User Preference
   * @param key key name of the preference 
   * @param value Stringify values of the preference key
   */
  saveUserPreference(key: string, value: object, loader = true) {
    const params = {
      preferenceKey: key,
      preferenceValue: value
    }
    return this.connectionService.httpReq({
      reqType: AppConstants.POSTREQUEST,
      endUrl: AppConstants.POST_PREFERENCE_USER,
      directoryType: AppConstants.DP,
      data: params,
      isLoader: loader
    });
  }

  /**
   * To Delete the preferences by Key
   * @param key params contains the preference key and an optional ID for specific deletion.
   */

  deleteUserPreference(params: DeleteListPaylaod) {
    const url = this.connectionService.encodeURL(AppConstants.DELETE_PREFERENCE,params)
    return this.connectionService.httpReq({
      reqType: AppConstants.DELETEREQUEST,
      endUrl: url,
      directoryType: AppConstants.DP,
      isLoader: true
    });
  }
}
 export interface DeleteListPaylaod {
  preferenceKey: string,
  id?: string
}

